
const TermsAndConditions = () => {
  // Estilos internos definidos como objetos
  const styles = {
    container: {
      backgroundColor: '#f9fafb',
      minHeight: '100vh',
      padding: '40px 20px',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      color: '#1f2937',
      lineHeight: '1.6',
    },
    card: {
      maxWidth: '800px',
      margin: '0 auto',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '40px',
      border: '1px solid #e5e7eb',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    },
    header: {
      borderBottom: '2px solid #e5e7eb',
      marginBottom: '30px',
      paddingBottom: '20px',
    },
    title: {
      color: '#2563eb',
      fontSize: '2rem',
      margin: '0 0 10px 0',
      fontWeight: '700',
    },
    metaData: {
      fontSize: '0.9rem',
      color: '#6b7280',
    },
    sectionTitle: {
      fontSize: '1.25rem',
      color: '#111827',
      marginTop: '30px',
      marginBottom: '15px',
      borderLeft: '4px solid #2563eb',
      paddingLeft: '15px',
      fontWeight: '600',
    },
    paragraph: {
      fontSize: '1rem',
      color: '#4b5563',
      marginBottom: '15px',
    },
    list: {
      paddingLeft: '20px',
      marginBottom: '20px',
    },
    listItem: {
      marginBottom: '8px',
      color: '#4b5563',
    },
    link: {
      color: '#2563eb',
      textDecoration: 'none',
    },
    footer: {
      textAlign: 'center',
      marginTop: '40px',
      color: '#9ca3af',
      fontSize: '0.85rem',
    }
  };

  return (
    <div style={styles.container}>
      <main style={styles.card}>
        <header style={styles.header}>
          <h1 style={styles.title}>Términos y Condiciones Vitaly App</h1>
          <div style={styles.metaData}>
            <p style={{ margin: '5px 0' }}><strong>Fecha de entrada en vigor:</strong> 27/01/2026</p>
            <p style={{ margin: '5px 0' }}><strong>Última actualización:</strong> 27/01/2026</p>
          </div>
        </header>

        <section>
          <h2 style={styles.sectionTitle}>1. Aceptación de los términos</h2>
          <p style={styles.paragraph}>
            Estos Términos y Condiciones regulan el acceso y uso de la aplicación móvil Vitaly (en adelante, la 
            "App"), operada por Vitaly. Al descargar, registrarte o utilizar la App, aceptas expresamente estos 
            Términos y Condiciones. Si no estás de acuerdo con ellos, debes abstenerte de utilizar la App.
          </p>

          <h2 style={styles.sectionTitle}>2. Identificación del titular</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Nombre comercial:</strong> Vitaly</li>
            <li style={styles.listItem}><strong>Sitio web:</strong> <a href="https://vitaly.care" style={styles.link}>https://vitaly.care</a></li>
            <li style={styles.listItem}><strong>Correo de contacto:</strong> <a href="mailto:vitalysuperapp@gmail.com" style={styles.link}>vitalysuperapp@gmail.com</a></li>
            <li style={styles.listItem}><strong>Dirección legal:</strong> Caracas, Venezuela</li>
          </ul>

          <h2 style={styles.sectionTitle}>3. Descripción del servicio</h2>
          <p style={styles.paragraph}>
            Vitaly es una plataforma digital orientada al bienestar, salud y servicios asociados, que permite a los 
            usuarios acceder a funcionalidades informativas, de gestión, seguimiento y comunicación relacionadas 
            con su bienestar.
          </p>
          <p style={styles.paragraph}>
            La App no sustituye la consulta, diagnóstico ni tratamiento médico profesional, salvo que se indique 
            expresamente lo contrario dentro de un servicio específico.
          </p>

          <h2 style={styles.sectionTitle}>4. Registro y cuenta de usuario</h2>
          <p style={styles.paragraph}>
            Para utilizar determinadas funcionalidades, el usuario debe crear una cuenta proporcionando 
            información veraz, completa y actualizada. El usuario es responsable de:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Mantener la confidencialidad de sus credenciales de acceso</li>
            <li style={styles.listItem}>Todas las actividades realizadas desde su cuenta</li>
            <li style={styles.listItem}>Notificar de inmediato cualquier uso no autorizado</li>
          </ul>

          <h2 style={styles.sectionTitle}>5. Uso permitido</h2>
          <p style={styles.paragraph}>Queda prohibido:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Usar la App con fines fraudulentos o ilegales</li>
            <li style={styles.listItem}>Introducir información falsa o de terceros sin autorización</li>
            <li style={styles.listItem}>Interferir con el funcionamiento de la App</li>
            <li style={styles.listItem}>Intentar acceder a sistemas o datos sin autorización</li>
          </ul>

          <h2 style={styles.sectionTitle}>6. Responsabilidades y limitaciones</h2>
          <p style={styles.paragraph}>
            El uso de la App se realiza bajo la exclusiva responsabilidad del usuario. Vitaly no será responsable por:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Daños derivados del uso o imposibilidad de uso de la App</li>
            <li style={styles.listItem}>Decisiones tomadas por el usuario basadas en la información proporcionada</li>
            <li style={styles.listItem}>Contenidos o servicios de terceros integrados o enlazados</li>
          </ul>

          <h2 style={styles.sectionTitle}>7. Contenidos y propiedad intelectual</h2>
          <p style={styles.paragraph}>
            Todos los contenidos de la App son propiedad de Vitaly o de sus licenciantes y están protegidos por las leyes de propiedad intelectual. Queda prohibida su reproducción sin consentimiento previo.
          </p>

          <h2 style={styles.sectionTitle}>12. Legislación aplicable y jurisdicción</h2>
          <p style={styles.paragraph}>
            Estos Términos y Condiciones se rigen por las leyes de la República Bolivariana de Venezuela. 
            Cualquier controversia será sometida a los tribunales competentes de la ciudad de Caracas, Venezuela.
          </p>

          <h2 style={styles.sectionTitle}>13. Contacto</h2>
          <p style={styles.paragraph}>
            Para cualquier duda o consulta, puedes contactarnos a través de:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Correo:</strong> vitalysuperapp@gmail.com</li>
            <li style={styles.listItem}><strong>Web:</strong> https://vitaly.care</li>
          </ul>
        </section>
      </main>

      <footer style={styles.footer}>
        <p>&copy; 2026 Vitaly. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default TermsAndConditions;